export function getConditionsMenuItems({ wl_link = "/treatment/weight-loss" } = {}) {
    return {
        common: [
            {
                n: "Cold and flu",
                url: "/treatment/cold-flu",
                footerOrder: 3,
            },
            {
                n: "Mental Health",
                name: "Mental health",
                url: "/treatment/mental-health",
                footerOrder: 2,
            },
            {
                n: "Urinary Tract Infections",
                name: "Urinary tract infection",
                url: "/treatment/urinary-tract-infection",
                k: "uti",
                footerOrder: 1,
            },
            {
                n: "Erectile Dysfunction",
                name: "Erectile dysfunction",
                url: "/treatment/erectile-dysfunction",
                k: "erectile-dysfunction",
                footerOrder: 6,
            },
            {
                n: "Premature Ejaculation",
                name: "Premature ejaculation",
                url: "/treatment/premature-ejaculation",
                k: "premature-ejaculation",
                footerOrder: 6,
            },
            {
                n: "Asthma",
                url: "/treatment/asthma",
                k: "-LJVyR5Pdls_ydzW8sRk",
                footerOrder: 4,
            },
            {
                n: "Weight Management",
                name: "Weight management",
                url: wl_link,
                k: "-N1fTGgW2ONhP0Zurrnn",
            },
            {
                n: "Nausea & Morning Sickness",
                name: "Nausea or vomiting",
                url: "treatment/nausea-morning-sickness",
                k: "/treatment/nausea-morning-sickness",
                footerOrder: 5,
            },
            {
                n: "Migraine And Headaches",
                name: "Migraines and headaches",
                url: "/treatment/migraines-headaches",
                k: "-LMfGlpF3oP3xgL52d7w",
            },
        ],
    };
}
